<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import FiltersDropdownCoach from '@/components/Filters/FiltersDropdown/FiltersDropdownCoach.vue';

const route = useRoute();
const router = useRouter();

// Get the coach filter from the route
const selectedCoachId = computed(() => {
  const coach = route.query.coach;
  return typeof coach === 'string' ? coach : undefined;
});

// Handle coach selection by updating the route
const handleCoachSelection = (coachId: string | undefined) => {
  router.push({
    path: route.path,
    query: {
      ...route.query,
      coach: coachId || undefined,
    },
  });
};
</script>

<template>
  <FiltersDropdownCoach
    :selected-coach-id="selectedCoachId"
    class="campaigns-filters-coach"
    icon="users"
    @update:selected-coach-id="handleCoachSelection">
  </FiltersDropdownCoach>
</template>

<style lang="scss" scoped>
.campaigns-filters-coach {
  min-width: 180px;
}
</style> 